import React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import { useMatching } from "./MatchingProvider";

/**
 * The `RefreshDialog` component displays a dialog for refreshing the page.
 * @component
 * @param {Object} props - The props of the component.
 * @param {Function} props.onClose - The function to close the dialog.
 * @return {JSX.Element} The `<RefreshDialog />` component.
 */

const RefreshDialog = ({ onClose = () => {} }) => {
  const { isRefreshing } = useMatching();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Dialog open={isRefreshing} onClose={onClose} maxWidth="xs">
      <DialogContent>
        <Alert severity="error">
          <AlertTitle>The page has been updated.</AlertTitle>
          Please refresh to see the latest changes.
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleRefresh} color="primary">
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshDialog;
